import {
  LOADING_SIGNUP,
  AUTH,
  LOADING_LOGIN,
  AUTH_ERROR,
  LOGOUT,
  LOADING_APP,
  ERRORS,
} from "./type";
import { apiURL } from "./api";
// import { useHistory } from 'react-router-dom';

export function signup(objs = {}, success = (f) => f, error = (f) => f) {
  return (dispatch) => {
    dispatch({ type: LOADING_SIGNUP });
    fetch(`${apiURL}/sign_up`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(objs),
    })
      .then((raw) => raw.json())
      .then((datas) => {
        console.log(datas, "DDDDDD", objs);
        const { user, token, taxID } = datas;
        dispatch({ type: LOADING_SIGNUP });
        if (datas.success) {
          dispatch(
            login(
              objs.email,
              objs.password,
              (data) => {
                success(datas);
                dispatch({ type: AUTH, payload: user[0] });
                if (token) {
                  localStorage.setItem("@@auth_token", token);
                }
              },
              (err) => {
                error(err);
                if (err && err.msg)
                  dispatch({
                    type: AUTH_ERROR,
                    payload: err,
                  });
              }
            )
          );
        } else {
          dispatch({
            type: AUTH_ERROR,
            payload: "Server error, try again.",
          });
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING_SIGNUP });
        console.log({ error });
      });
  };
}

export function login(
  { username, password },
  success = (f) => f,
  error = (f) => f
) {
  return (dispatch) => {
    dispatch({ type: LOADING_LOGIN });
    fetch(`${apiURL}/sign_in`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    })
      .then((raw) => raw.json())
      .then((data) => {
        console.log(data, "KKDKDKDDK");
        dispatch({ type: LOADING_LOGIN });
        if (data.success) {
          const { token } = data;
          const { user } = data;
          dispatch({ type: AUTH, payload: user });
          // console.log(token, "tOKEN HERE");
          if (token) {
            // alert(token);
            localStorage.setItem("@@auth_token", token);
            // alert(JSON.stringify(token));
          }
          success(data);
          getUserProfile(token);
        } else {
          dispatch({ type: ERRORS, payload: data.msg });
          error(data);
          console.log(data, "ERRRRRROOOOOORRRR");
        }
      })
      .catch((err) => {
        dispatch({ type: LOADING_LOGIN });
        error(err);
        console.log("", "ERROR");
      });
  };
}

export async function getUserProfile(_token) {
  try {
    // alert(_token);

    // Set a timeout for the fetch request to prevent hanging
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

    let response = await fetch(`${apiURL}/verify-token`, {
      method: "GET",
      headers: {
        authorization: "Bearer " + _token,
      },
      signal: controller.signal
    });
    clearTimeout(timeoutId);

    if (!response.ok) {
      // Return a failure response if the HTTP status is not OK
      return { success: false, msg: `API error: ${response.status}` };
    }

    let data = await response.json();
    return data;
  } catch (error) {
    console.error("API error in getUserProfile:", error);
    // Return a failure response in case of error
    return { success: false, msg: "Network error or server not responding" };
  }
}

export function init(history) {
  return async (dispatch) => {
    try {
      let token = localStorage.getItem("@@auth_token");

      if (token) {
        // Token present, verify it
        const data = await getUserProfile(token);

        if (data && data.success) {
          // Token is valid
          dispatch({ type: LOADING_APP });
          const { user } = data;
          dispatch({ type: AUTH, payload: user });
        } else {
          // Invalid token, remove it
          localStorage.removeItem("@@auth_token");
        }
      }
      // If no token, user will be redirected to sign-in by the router
    } catch (error) {
      // Clear token on error to prevent hanging on init
      localStorage.removeItem("@@auth_token");
      console.warn("Auth initialization error (this is normal if API is not available):", error);
      // Don't dispatch error for initialization - let the UI handle routing
    }
  };
}

export function logout() {
  return (dispatch) => {
    localStorage.removeItem("@@auth_token");
    window.location.replace("/");
    dispatch({ type: LOGOUT });
  };
}
